import { FormControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { Directive } from '@angular/core';

export const STOCK_ID_PREFIX_REGEX = '^[a-zA-Z0-9]{1,14}[a-zA-Z]$';

@Directive({
    standalone: true,
    selector: '[jhi-stockIdPrefixValidator][ngModel]',
    providers: [{ provide: NG_VALIDATORS, useExisting: StockIdPrefixValidatorDirective, multi: true }]
})
export class StockIdPrefixValidatorDirective implements Validator {
    validate(c: FormControl) {
        const REGEXP = new RegExp(STOCK_ID_PREFIX_REGEX, 'i');
        return REGEXP.test(c.value) || !c.value ? null : {
            stockIdPrefix: {
                valid: false
            }
        };
    }
}
